import { GetHamburgerMenusGateway } from '@remodeling/content';
import { axios } from '../../axios';

export const CategoryGateway = () => {
  return {
    getHamburgerMenus: new GetHamburgerMenusGateway(axios),
  };
};
